import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar.component";
import Footer from "../components/footer.component";
import SideBot from "../assets/images/sideBot.svg";

const Video = () => {
  return (
    <>
      <Navbar />
      <div className="my-16">
        <div className="d-flex mb-16">
          <div className="w-full p-10 m-16" style={{ margin: "150px 100px 220px 220px" }}>
            <h1
              className="display-2 font-link"
              style={{ fontWeight: "bolder", marginBottom: "60px" }}
            >
              video interview.
            </h1>

            <div className="fs-4 mb-16" style={{ width: "60%" }}>
              <p>
                Use the <strong>InterviewIQ</strong> video simulator and get real-time feedback
                on how our AI interprets your facial emotions compared to other candidates.
              </p>
              <br />
              <p style={{ fontWeight: "lighter" }}>
                You will receive a detailed report on emotions such as:
              </p>
              <br />
              <p style={{ fontWeight: "lighter" }}>
                Anger &nbsp;|&nbsp; Happiness &nbsp;|&nbsp; Fear &nbsp;|&nbsp; Sadness &nbsp;|&nbsp; Surprise &nbsp;|&nbsp; Disgust
              </p>
            </div>
            <br />
            <br />

            <div className="gap-2">
              <Link to="/interview/v">
                <button
                  type="button"
                  className="btn btn-dark px-3 py-2"
                  style={{ margin: "20px" }}
                >
                  Start Interview
                </button>
              </Link>
              <Link to="/video_dash">
                <button type="button" className="btn btn-outline-dark py-2">
                  View Results
                </button>
              </Link>
            </div>
          </div>

          <div>
            <div className="w-96 h-full">
              <img src={SideBot} className="h-full w-full" alt="Side Bot" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Video;
